import React from "react";

const styles = {
  container: {
    padding: '10px 0',
  },
  title: {
    fontWeight: 'bold'
  },
  table: {
    width: '100%',
    border: '1px solid',
    borderCollapse: 'collapse',
    boxSizing: 'border-box'
  },
  thead: {
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  },
  th: {
    textAlign: 'left',
    padding: '2px 8px',
    fontSize: '13px'
  },
  descriptionTitle: {
    marginBottom: '8px'
  },
  center: {
    textAlign: 'center',
  },
  top: {
    verticalAlign: 'top'
  },
  tdTitle: {
    textAlign: 'center',
    height: '1px'
  },
  tdDescription: {
    height: '1px',
    paddingTop: '16px',
    paddingBottom: '16px'
  },
  td: {
    border: '1px solid',
    fontSize: '13px',
    padding: '8px'
  },
  tdImage: {
    width: '30%',
    textAlign: 'center',
    borderRight: 'none'
  },
  tdImgSelector: {
    borderLeft: 'none'
  }
};

const GageDimensions = ({product, removableArea: RemovableArea}) => (
  <RemovableArea
    data-removable={true}
    id="gageDimensions"
    style={styles.container}
  >
    <table border="1px solid" cellSpacing="0"
           style={styles.table}>
      <thead style={styles.thead}>
      <tr>
        <th colSpan="7" style={styles.th}>
          GAGE DIMENSIONS
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td style={styles.td}></td>
        <td style={{...styles.td, ...styles.tdTitle}}>
          <span style={styles.title}>Gage Length</span>
        </td>
        <td style={{...styles.td, ...styles.tdTitle}}>
          <span style={styles.title}>Matrix Length</span>
        </td>
        <td style={{...styles.td, ...styles.tdTitle}}>
          <span style={styles.title}>Overall Length</span>
        </td>
        <td style={{...styles.td, ...styles.tdTitle}}>
          <span style={styles.title}>Grid Width</span>
        </td>
        <td style={{...styles.td, ...styles.tdTitle}}>
          <span style={styles.title}>Matrix Width</span>
        </td>
        <td style={{...styles.td, ...styles.tdTitle}}>
          <span style={styles.title}>Overall Width</span>
        </td>
      </tr>
      <tr>
        <td style={styles.td}>inch</td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.length.gage_inch}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.length.matrix_inch}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.length.overall_inch}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.width.grid_inch}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.width.matrix_inch}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.width.overall_inch}
        </td>
      </tr>
      <tr>
        <td style={styles.td}>millimeter</td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.length.gage_mm}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.length.matrix_mm}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.length.overall_mm}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.width.grid_mm}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.width.matrix_mm}
        </td>
        <td style={{...styles.td, ...styles.center}}>
          {product.dimensions?.width.overall_mm}
        </td>
      </tr>
      </tbody>
    </table>
  </RemovableArea>
);

export default GageDimensions;
